// Libs
import { ModelBase } from "@shoothill/core";
import * as MobX from "mobx";
import { StoresInstance } from "Globals/Stores";

// Dto
import { CreditReportDTO } from "Globals/Models/DTO/CreditReportDTO";

export class CreditReportModel extends ModelBase<CreditReportModel, CreditReportDTO> {
    @MobX.observable public id: string | null = null;
    @MobX.observable public formId: string = "";
    @MobX.observable public applicantId: string = "";
    @MobX.observable public creditDocumentUrl: string = "";
    @MobX.observable public creditFileName: string = "";
    @MobX.observable public createdDate: Date | null = null;
    @MobX.observable public isDeleted: boolean = false;

    @MobX.action
    public fromDto = (model: CreditReportDTO): void => {
        if (model !== null && model !== undefined) {
            this.id = model.id;
            this.formId = model.formId;
            this.applicantId = model.applicantId;
            this.creditDocumentUrl = model.creditDocumentUrl;
            this.creditFileName = model.creditFileName;
            this.createdDate = model.createdDate;
            this.isDeleted = model.isDeleted;
        }
    };

    @MobX.action
    public toDto = (): CreditReportDTO => {
        let model: CreditReportDTO = {
            id: this.id,
            formId: this.formId,
            applicantId: this.applicantId,
            creditDocumentUrl: this.creditDocumentUrl,
            creditFileName: this.creditFileName,
            createdDate: this.createdDate,
            isDeleted: this.isDeleted,
        };
        return model;
    };

    @MobX.action
    public resetModel = (): void => {
        this.id = "";
        this.applicantId = "";
        this.creditDocumentUrl = "";
        this.creditFileName = "";
        this.createdDate = null;
        this.isDeleted = false;
    };
}
